import api from '@motionelements/core/src/api/base-api-v2';

const baseUrl = '/v2/media-types';

export default {
  all(params) {
    return api.get(baseUrl, {
      params: {
        ...params,
      },
    });
  },
  get({ mediaType, field }) {
    const url = `${baseUrl}/${mediaType}/${field}`;
    return api.get(url).then(({ data: { data } }) => data);
  },
};
